module.exports = __webpack_public_path__ + "img/es-banner-bekr.2f5704af.png";